import React from 'react';
import { Box, Stack, Typography, SxProps, Theme } from '@mui/material';

interface SummaryNumberProps {
  children?: React.ReactNode;
  value?: number;
  range?: { min: number; max: number };

  typographyStyle?: SxProps<Theme>;

  superscript?: number;
  subscript?: number;
  sx?: React.CSSProperties;

  info?: boolean;
}

export const CustomNumber = ({
  children,
  value,
  range,

  typographyStyle,

  superscript,
  subscript,
}: SummaryNumberProps) => {
  const dataIsNotUndefined = value !== undefined && range !== undefined;

  const textColor =
    dataIsNotUndefined && value > range.max
      ? 'success.light'
      : dataIsNotUndefined && value <= range.min
      ? 'error.light'
      : 'inherit';

  if (superscript || subscript) {
    return (
      <Box display="flex" flexDirection="row" alignItems="center">
        <Typography
          variant="h1"
          color={textColor}
          paddingLeft={'5px'}
          sx={typographyStyle}
        >
          {children}
        </Typography>
        {!!superscript || !!subscript ? (
          <Stack
            ml={'10px'}
            display="flex"
            sx={{
              justifyContent: !superscript ? 'end' : 'inherit',
            }}
          >
            {!!superscript && (
              <Box
                display="flex"
                flexDirection="row"
                alignItems="center"
                height="13px"
              >
                <Typography sx={{ ...typographyStyle, fontSize: '11px' }}>
                  +{superscript}
                </Typography>
              </Box>
            )}
            {!!subscript && (
              <Box
                display="flex"
                flexDirection="row"
                alignItems="center"
                justifyContent="end"
                height="13px"
              >
                <Typography sx={{ ...typographyStyle, fontSize: '11px' }}>
                  -{subscript}
                </Typography>
              </Box>
            )}
          </Stack>
        ) : null}
      </Box>
    );
  }

  return (
    <Typography
      variant="h1"
      color={textColor}
      paddingLeft={'5px'}
      sx={typographyStyle}
    >
      {children}
    </Typography>
  );
};
